export default __webpack_public_path__ + "static/media/A Statment on the human resources planning.f7b51680.pdf";